import { useState, useEffect, useRef } from 'react';
import { Artist } from '../types/artist';
import { searchArtists } from '../services/artistApi';

export function useArtistSearch(debounceMs: number = 400) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState<Artist[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current);

    if (!query || query.trim().length < 2) {
      setResults([]);
      setError(null);
      return;
    }

    timerRef.current = setTimeout(async () => {
      setIsLoading(true);
      setError(null);
      try {
        const { artists } = await searchArtists(query.trim());
        setResults(artists);
      } catch (err: any) {
        setError(err.message || 'Search failed');
        setResults([]);
      } finally {
        setIsLoading(false);
      }
    }, debounceMs);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [query, debounceMs]);

  return { query, setQuery, results, isLoading, error };
}
